/*
 * @version: V1.0.0
 * @Date: 2023-10-30 09:15:06
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-02 10:15:46
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\login\index.js
 * @Descripttion:
 */
import request from '@/utils/request'
// 登录方法
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}


// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// saas获取菜单
export function getRouters() {
  return request({
    url: '/getRoutersV4/4',
    method: 'get'
  })
}
// saas获取按钮权限
export function getbtn() {
  return request({
    url: '/btn/resource/4',
    method: 'get'
  })
}


// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get',
    timeout: 20000
  })
}
/**
 * @description: 检查用户是否已知晓版本变更内容
 * @return {*}
 */
export function checkUserVersionUpdateStatus() {
  return request({
    url: '/system/versionsUpdate/updateAlert',
    method: 'get',
    params: {
      port: 'server',
      appValue: 'wms'
    }
  })
}

/**
 * @description: 更改用户已知晓版本更新内容状态
 * @return {*}
 */
export function changeUserVersionUpdateStatus(id) {
  return request({
    url: '/system/versionsUpdate/certain',
    method: 'post',
    data: {
      port: 'server',
      appValue: 'wms',
      id
    }
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/userUpdate',
    method: 'post',
    data
  })
}

// 用户密码重置
export function updateUserPwd(data) {
  return request({
    url: '/system/user/passUpdate',
    method: 'post',
    data
  })
}